import './icon-button.css';

interface IconButtonProps {
    IconComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    onClick: () => void;
    withBorder?: boolean;
    backgroundColor?: string;
}

function IconButton(props: IconButtonProps) {
    const { IconComponent, onClick, withBorder, backgroundColor } = props;
    const style: React.CSSProperties = {};
    if (backgroundColor) {
        style.backgroundColor = backgroundColor;
    }

    return (
        <div className="icon-button-wrapper">
            <button
                className={'icon-button' + (withBorder ? ' with-border' : '')}
                style={style}
                onClick={onClick}
                // Prevents the item from focusing, which resolves a bug
                // where clicking an item, then pressing enter to resolve another
                // effect will cause it to "click" the item again.
                onMouseDown={(event) => {
                    event.preventDefault();
                }}
            >
                <IconComponent />
            </button>
            {withBorder && <div className="icon-button-mask" />}
        </div>
    );
}

export default IconButton;
